<template>
  <app-badge
    :size="size"
    :class="['capitalize', badgeStyle]"
    data-sentry-unmask
  >
    <app-icon
      :name="badgeIcon"
      class="size-3"
    />
    {{ StatementStatusLabel[status] }}
  </app-badge>
</template>

<script setup>
import { computed } from 'vue';
import { StatementStatusLabel, StatementStatusBadgeStyle, StatementStatusIcon } from '@/constants/statements';

const props = defineProps({
  size: {
    type: String,
    default: 'sm',
  },
  status: {
    type: String,
    required: true,
  },
});

const badgeStyle = computed(() => StatementStatusBadgeStyle[props.status]);

const badgeIcon = computed(() => StatementStatusIcon[props.status]);
</script>
